import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import './ModalNotSaveInformation.scss';

const ModalNotSaveInformation = ({ open, handleAceptModal, setOpenSaveInfModal }) => {
  const handleCerrar = () => {
    console.log(setOpenSaveInfModal(false));
  };

  return (
    <Modal footer={null} width="33em" open={open} centered destroyOnClose>
      <span className="box-gral">
        <div className="modal-cancelacion">
          <span>
            ¿Estás seguro que deseas salir? <br />
            Se perderá la información capturada.
          </span>
        </div>
        <div className="buttons-cancel">
          <Button className="buttons-cancel" onClick={handleCerrar}>
            Cancelar
          </Button>
          <span style={{ width: '6rem' }} />
          <Button type="primary" className="buttons-cancel" onClick={handleAceptModal}>
            Aceptar
          </Button>
        </div>
      </span>
    </Modal>
  );
};

ModalNotSaveInformation.propTypes = {
  open: PropTypes.bool.isRequired,
  handleAceptModal: PropTypes.func.isRequired,
  setOpenSaveInfModal: PropTypes.func.isRequired
};

export default ModalNotSaveInformation;
